import { ChangeModifierPositionActionTypes, TChangeModifierPositionActions } from './changeModifierPositionActions';
import { IChangeModifierPositionState } from './changeModifierPositionContext';

export const changeModifierPositionReducer = (
	state: IChangeModifierPositionState,
	action: TChangeModifierPositionActions,
): IChangeModifierPositionState => {
	switch (action.type) {
		case ChangeModifierPositionActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				IDSelectedRestaurant: null,
				IDSelectedModifierGroup: null,
				positionsData: [],
			};
		case ChangeModifierPositionActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				IDSelectedModifierGroup: null,
				positionsData: [],
			};
		case ChangeModifierPositionActionTypes.SET_ID_MODIFIER_GROUP:
			return {
				...state,
				IDSelectedModifierGroup: action.payload.IDSelectedModifierGroup,
				positionsData: [],
			};
		case ChangeModifierPositionActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				IDSelectedCustomer: null,
				IDSelectedRestaurant: null,
				IDSelectedModifierGroup: null,
				positionsData: [],
			};
		case ChangeModifierPositionActionTypes.SET_POSITIONS_DATA:
			return {
				...state,
				positionsData: action.payload.positionsData,
			};
		case ChangeModifierPositionActionTypes.REORDER_ITEMS:
			return {
				...state,
				positionsData: action.payload.newOrder,
			};
		case ChangeModifierPositionActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case ChangeModifierPositionActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		default:
			return state;
	}
};
